import config from 'src/config'
import categories from 'src/json/categories.json'

export function getLocalizedCategoryData(category: any, language: string) {
  const centraCode =
    config.locales && config.locales[language]
      ? config.locales[language].centraCode
      : null
  if (
    centraCode &&
    category &&
    category.localized &&
    category.localized[centraCode]
  ) {
    return {
      ...category,
      ...category.localized[centraCode],
    }
  } else {
    return {
      ...category,
    }
  }
}

export function getCategoriesByBrand(brand: number) {
  return categories
    .filter((cat: any) => !cat.inCategory && cat.brands.includes(brand))
    .sort((a: any, b: any) => (a.sortOrder > b.sortOrder ? 1 : -1))
}

export function getCategoryBySlug(slug: string) {
  return categories.find((cat: any) => cat.uri === slug)
}
